type ProgressBarProps = {
  progressBarText: string;
  currentProgressCount: number;
  maxProgressCount: number;
};

export const ProgressBar = ({ progressBarText, currentProgressCount, maxProgressCount }: ProgressBarProps) => (
  <div className="mb-4">
    <div className="flex items-center justify-between mb-1">
      <p className="text-sm font-medium">{progressBarText}</p>
      <span className="text-sm font-medium">
        {Math.min(100, Math.round((currentProgressCount / maxProgressCount) * 100))}%
      </span>
    </div>
    <div className="w-full bg-gray-200 rounded-full h-2.5">
      <div
        className="bg-igus-primary h-2.5 rounded-full transition-all duration-300"
        style={{ width: `${Math.min(100, Math.round((currentProgressCount / maxProgressCount) * 100))}%` }}
      />
    </div>
  </div>
);
